import React from 'react';
import Responsive, { MediaQueryMatchers } from 'react-responsive';
import { breakpoints } from '@99designs/emu/settings';

export interface Props {
    children: React.ReactNode;
    values?: Partial<MediaQueryMatchers>;
}

export const Desktop = ({ children, values }: Props) => (
    <Responsive minWidth={breakpoints.normal[0]} children={children} values={values} />
);
export default Desktop;
